import { useAccountStore } from '../store/store.account'
import axios from 'axios';
import { setupCache } from 'axios-cache-interceptor';
import { Store, StoreDefinition, getActivePinia } from 'pinia'

export const baseURL = 'https://api.sacksgroup.ru/'

const checkStoreAvailability = (): Promise<void> => {
  return new Promise((resolve) => {
    const check = () => {
      if (getActivePinia()) resolve()
      else setTimeout(check, 100)
    }
    check()
  })
}

async function sleep(millis: number) {
  await new Promise((resolve) => setTimeout(resolve, millis))
}

const axiosBase = axios.create({
  baseURL,
  headers: {
    'content-type': 'application/json',
    localization: 'ru',
  },
});

const axiosBaseAdmin = axios.create({
  baseURL,
  headers: {
    'content-type': 'application/json',
    localization: 'ru',
  },
});

const client = setupCache(axiosBase, {
  cacheTakeover: false,
});

const admin = axiosBaseAdmin;

client.interceptors.request.use(async (request) => {
  const token = localStorage.getItem('token');

  if (token) {
    request.headers.Authorization = `Token ${token}`;
  }
  return request;
});

admin.interceptors.request.use(async (requestAdmin) => {
  const token = localStorage.getItem('admin-token');

  if (token) {
    requestAdmin.headers.Authorization = `Token ${token}`;
  }

  return requestAdmin;
});


export { client, admin }
